

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.b40449df.js","_app/immutable/chunks/scheduler.2cb4bb00.js","_app/immutable/chunks/index.7d06ba6e.js","_app/immutable/chunks/stores.ea5c5f45.js","_app/immutable/chunks/singletons.ac7f5a04.js","_app/immutable/chunks/each.b817d3ea.js","_app/immutable/chunks/navigation.52941e7a.js"];
export const stylesheets = ["_app/immutable/assets/0.34d1495f.css"];
export const fonts = [];
